import { registerPage } from '@ja/portal/pageRegistry'

registerPage('workforce-requests', 'Base/RequestList', () => import('./Pages/RequestList.vue'))
registerPage('workforce-requests', 'Base/RequestCreateForm', () => import('./Pages/RequestCreateForm.vue'))
registerPage('workforce-requests', 'Base/RequestApprovalPanel', () => import('./Pages/RequestApprovalPanel.vue'))
registerPage('workforce-requests', 'Base/RequestShow', () => import('./Pages/RequestShow.vue'))
